export enum StatusProcess {
  Enviado = 'Enviado',
  Revisado = 'Revisado',
  Preseleccionado = 'Preseleccionado',
  Seleccionado = 'Seleccionado'
}
